import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../Component/Layout/Header';
import { CheckLoader } from '../Redux/action/roleManageAction';
import MemberInformationPannel from '../Component/CommonComponent/MemberInformationPannel';
import MainHeadingAddRole from '../Component/CommonComponent/MainHeadingAddRole';
import MainHeadingFilterRole from './CommonComponent/MainHeadingFilterRole';
import MainRoleTable from '../Component/CommonComponent/MainRoleTable';
import {
  allMember,
  exportFileFunc,
  addBulkUploadFile,
} from '../Redux/action/memberAction';
import { CSVLink } from 'react-csv';
import axios from 'axios';
// import { CheckLoader } from '../Redux/action/visitorAction';
import { dataUser } from './Helpers/util';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import moment from 'moment';

import Sidebar from '../Component/Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import { Layout } from 'antd';
import SwButton from './Common/SwButtons/SwButtons';
import SwInput from './Common/FormComponent/SwInput';

var exportData = [];

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class RoleMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolelistdata: [],
      company_id: UserObj ? UserObj.company_id : null,
      row: 25,
        tableLoading: false,
      pgno: 1,
      setfilter: {},
      status: '',
      order: '',
      users: null,
      stateValsort: {
        dropdown: false,
      },
      collapsed: true,
      fileName: '',
      orgRole: [],
      totalRole: 0,
      accessServiceLists: [],
      loaderServiceAccess: true,
      searchText: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
    this.handelDropdown = this.handelDropdown.bind(this);
  }

  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  uploadImg = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      let repalceUrl = convertBase64.replace('vnd.ms-excel', 'csv');
      this.setState({
        users: repalceUrl,
        fileName: event.target.files[0].name,
      });
    };
  };

  refreshPage = e => {
    window.location.reload();
  };

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }
  addimportfile = e => {
    e.preventDefault();
    let param = {
      company_id: this.state.company_id,
      users: this.state.users,
    };
    this.props.addBulkUploadFile(param);
  };

  setSelectsort = e => {
    this.setState({
      order: e.target.value,
    });

    setTimeout(() => {
      this.RoleMember();
    }, 500);
  };
  selectRows = e => {
    this.setState({
      [e.target.name]: e.target.value,
      pgno: 1,
    });
    let parms1 = {
      order: this.state.order,
      row: e.target.value,
      status: this.state.status,
      pgno: this.state.pgno + 1,
      company_id: this.state.company_id,
    };
    let parms2 = {
      order: this.state.order,
      row: e.target.value,
      pgno: this.state.pgno + 1,
      company_id: this.state.company_id,
    };
    let vparam = this.state.status != '' ? parms1 : parms2;
   
    setTimeout(() => {
      this.RoleMember();
    }, 500);
  };

  chnageSelectMembers = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });

    setTimeout(() => {
      this.RoleMember();
    }, 500);
  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
      orgRole: [],
    });
    let parms1 = {
      order: this.state.order,
      row: this.state.row,
      status: this.state.status,
      pgno: this.state.pgno + 1,
      company_id: this.state.company_id,
    };
    let parms2 = {
      ...this.state.setfilter,
      order: this.state.order,
      row: this.state.row,
      pgno: this.state.pgno + 1,
      company_id: this.state.company_id,
    };

    let vparam = this.state.status != '' ? parms1 : parms2;
  

    // this.props.allMember(vparam);
    setTimeout(() => {
      this.RoleMember();
    }, 500);

    let newParam = {
      pgno: this.state.pgno + 1,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    // this.props.exportFileFunc(newParam);
  }

  pageBackword() {
    this.setState({
      pgno: this.state.pgno - 1,
      orgRole: [],
    });

    let parms1 = {
      order: this.state.order,
      row: this.state.row,
      status: this.state.status,
      pgno: this.state.pgno - 1,
      company_id: this.state.company_id,
    };
    let parms2 = {
      ...this.state.setfilter,
      order: this.state.order,
      row: this.state.row,
      pgno: this.state.pgno - 1,
      company_id: this.state.company_id,
    };
    let vparam = this.state.status != '' ? parms1 : parms2;

    let newData = {
      pgno: this.state.pgno - 1,
      row: this.state.row,
      company_id: this.state.company_id,
    };

    
    // this.props.allMember(vparam);
    setTimeout(() => {
      this.RoleMember();
    }, 500);
    // this.props.exportFileFunc(newData);
  }

changeFilterData = e => {
  const value = e.target.value;

  this.setState(
    {
      searchText: value,
      pgno: 1, // always reset page when searching
    },
    () => {
      this.RoleMember(); // ✅ API after state updated
    }
  );
};

  async getTotalCount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    const total = await axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }userRoles/getAllRolesByOrg?company_id=202&pgno=1&row=1&text=&type=&sort_by=`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        return response?.data?.data?.total;
      });
    this.getAllExportData(total);
  }

  getAllExportData(totalCount) {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }userRoles/getAllRolesByOrg?company_id=202&pgno=1&row=${totalCount}&text=&type=&sort_by=`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        exportData = response.data.data.result;
      });
  }

  RoleMember() {
    let authToken = JSON.parse(localStorage.getItem('headData'));
this.setState({ tableLoading: true });
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }userRoles/getAllRolesByOrg?company_id=${this.state.company_id}&pgno=${
          this.state.pgno
        }&row=${this.state.row}&text=${this.state.searchText}&type=${
          this.state.status
        }&sort_by=${this.state.order}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
    .then(response => {
  if (response.data && response.data.status === 'success') {
    const result = response.data.data.result || [];
    const total = response.data.data.total || result.length;

    this.setState({
      orgRole: result,
      totalRole: total,   // 🔥 important
      tableLoading: false,
    });
  }
})
    .catch(err => {
  console.log('Error: ' + err);
  this.setState({ tableLoading: false }); // ✅ stop loader on error
});
    // this.props.exportFileFunc(newData);
  }

RoleMemberSort = sortValue => {
  let authToken = JSON.parse(localStorage.getItem('headData'));

  this.setState({ tableLoading: true });

  const url = `${process.env.REACT_APP_API_URL}userRoles/getAllRolesByOrg?company_id=${this.state.company_id}&pgno=${this.state.pgno}&row=${this.state.row}&text=${this.state.searchText || ''}&type=${this.state.status || ''}&sort_by=${sortValue || ''}`;

  axios
    .get(url, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(response => {
      if (response.data && response.data.status === 'success') {
        this.setState({
          orgRole: response.data.data.result,
          totalRole: response.data.data.total,
          tableLoading: false,
          order: sortValue, // ✅ keep order in state
        });
      }
    })
    .catch(err => {
      console.log('Error: ', err);
      this.setState({ tableLoading: false });
    });
};


  FilterData = updatedData => {
    this.setState({
      orgRole: updatedData.result,
      totalRole: updatedData.total,
    });
  };
  setuserlist = () => {
    let param = {
      pgno: 1,
      company_id: this.state.company_id,
      row: this.state.row,
    };
    // this.props.allMember(param);
    this.RoleMember();
  };

  setExport = () => {
    var paramData = {
      pgno: 1,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    this.props.exportFileFunc(paramData);
  };

  componentDidMount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }userRoles/getAllRolesByOrg?company_id=${this.state.company_id}&pgno=${
          this.props.pg
        }&row=${this.props.rw}&text=${this.state.searchText}&type=${
          this.state.status
        }&sort_by=${this.state.order}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status == 'success') {
          this.setState({
            rolelistdata: response.data.data.result,
          });
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
    this.setuserlist();
    this.setExport();
    this.getTotalCount();
  }



  

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  render() {
    const Roles = this.state.userRole.find(
      element => element.service_id == '13',
    );
    const activeUserList = this.props.activeUserList.userList;
    const exportlistData = this.props.exportList.exportData;

    const listLength =
      this.props.activeUserList.userList.list !== undefined
        ? this.props.activeUserList.userList.list.length
        : 0;

    const loader = this.props.activeUserList.loader;
    const headers = [
      { label: 'Role Name', key: 'role_name' },
      { label: 'Date Created', key: 'added_at' },
      { label: 'Created By', key: 'full_name' },
      { label: 'Last Updated', key: 'updated_at' },
      { label: 'Updated By', key: 'updated_name' },
      { label: 'Status', key: 'status' },
    ];
    exportData.map(items => {
      items['status'] = items.role_status === '1' ? 'Active' : 'In Active';
      items['full_name'] = `${
        items.added_by_fname == null ? '-' : items.added_by_fname
      } ${items.added_by_lname == null ? '-' : items.added_by_lname}`;
      items['updated_name'] = `${
        items.updated_by_fname == null ? '-' : items.updated_by_fname
      } ${items.updated_by_lname == null ? '-' : items.updated_by_lname}`;
    });

    var alldata = exportData.map(v => ({
      status: v.status,
      added_at: moment.unix(v.added_at).format('YYYY-MM-DD HH:mm:ss'),
      role_name: v.role_name,
      full_name: v.full_name,
      updated_at: moment.unix(v.updated_at).format('YYYY-MM-DD HH:mm:ss'),
      updated_name: v.updated_name,
    }));
    const Loader = this.props.visitorReducer.loader;
    let serviceAccess = true;
    const serviceAccessId = 13;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    return (
      <>
        <Layout>
          <Sidebar collapsed={this.state.collapsed} />

          {/* <Header activePg={this.state.pgno} activeRow={this.state.row} /> */}

          <CustomHeader
            activePg={this.state.pgno}
            activeRow={this.state.row}
            collapsed={this.state.collapsed}
            toggleCollapsed={this.toggleCollapsed}
          />

          <Layout
            className={
              this.state.collapsed
                ? 'PageLayout CollapsedPageLayout'
                : 'PageLayout'
            }
          >
            {serviceAccess === true ? (
              <>
                <div
                  className="custome modal right fade "
                  id="myModal_sort"
                  data-backdrop="static"
                >
                  <div className="modal-dialog popcustomewidth ">
                    <div className="modal-content ">
                      <div className="formTitle">
                        Import Role
                        <button
                          type="button"
                          className="relateDox close"
                          data-dismiss="modal"
                        >
                          x
                        </button>
                      </div>
                      {/* <div className="modal-body ">
                <div className="maintapn">
                  <div className="leftimportBox">
                    <p> Download excel template from here</p>
                    <>
                      <a
                        href="https://smartworks-web-staging.s3.ap-southeast-1.amazonaws.com/Template%2Buser%2Badd%2B-%2BCopy.csv"
                        download
                      >
                        <img src="img/submen3.svg" /> Export Roles
                      </a>
                    </>
                  </div>
                  <div className="rightimportBox">
                    <p>Upload excel file here</p>
                    <label className="setUpload">
                      <input
                        type="file"
                        className="Uploadfilebtn parset"
                        onChange={(e) => {
                          this.uploadImg(e);
                        }}
                      />
                      <img className="imageSize" src="img/upload.svg" /> Upload
                    </label>
                    <p style={{ "font-size": "12px", "margin-top": "49px" }}>
                      {this.state.fileName}
                    </p>
                  </div>
                  <div className="clearfix"></div>
                  <div className="centerbox">
                    <button
                      className="btn btn-primary downloadbrn"
                      onClick={this.addimportfile}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div> */}
                    </div>
                  </div>
                </div>

                <div className="PageContent">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="SwHeading">
                        <h2>Manage Roles</h2>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="PageHead_Optons_Row">
                        <ul className='PageHead_Optons_RightAligned'>
                          <li>
                            <div className="SwInputWithIcon">
                              <SwInput
                                placeholder="Search..."
                                value={this.state.searchText}
                                onChange={this.changeFilterData}
                              />
                              <span className="SwInputicon">
                                <i className="bi bi-search" />
                              </span>
                            </div>
                          </li>
                          <li className='nn'>
                            <MainHeadingFilterRole
                              filterPg={this.state.pgno}
                              clearSearch={this.clearSearchBox}
                              filterRow={this.state.row}
                              companyid={this.state.company_id}
                              // onSelectLanguage={this.handleLanguage}
                              FilterData={this.FilterData}
                            />
                          </li>

                          <li>
                            <CSVLink
                              data={alldata}
                              headers={headers}
                              filename={'roles.csv'}
                              onClick={this.handelDropdown}
                            >
                              <SwButton
                                type="button"
                                variant="dark"
                                size="sm"
                                icon={<i class="bi bi-box-arrow-up-right" />}
                                iconPosition="start"
                              >
                                <span />
                                Export
                              </SwButton>
                            </CSVLink>
                          </li>
                          <li>
                            {(Roles && Roles.role_for_write == '1' ? (
                              true
                            ) : (
                              false
                            )) ? (
                              <MainHeadingAddRole />
                            ) : (
                              ''
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <MainRoleTable
                        roleList={this.state.orgRole}
                        totalRole={this.state.totalRole}
                        pg={this.state.pgno}
                        rw={this.state.row}
                        loading={this.state.tableLoading}
                        doIt={this.RoleMemberSort}
                        onPageChange={(page, size) => {
                          this.setState(
                            {
                              pgno: page,
                              row: size,
                            },
                            () => {
                              this.RoleMember(); // 🔥 CALL API AFTER STATE UPDATE
                            }
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : this.state.loaderServiceAccess == true ? (
              <>
                <div className="loader">
                  <img
                    className=""
                    src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                    alt="Loder"
                  />
                </div>
              </>
            ) : (
              <MarketingPanel />
            )}
          </Layout>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  activeUserList: state.activeUserList,
  exportList: state.activeUserList,
  visitorReducer: state.visitorReducer,
});

const mapActionsToProps = {
  allMember,
  CheckLoader,
  exportFileFunc,
  addBulkUploadFile,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoleMember);
